import { universalServices } from "./UniversalServices";

class DataBaseService {
  constructor() {}
  //eslint-disable-next-line
  async getDBStatus(): Promise<any> {
    try {
      const response = await universalServices.getData("auth", "get-db-status");

      return {
        success: response.success,
        message: response.message,
      };
    } catch (e) {
      const message = e instanceof Error ? e.message : typeof e === "string" ? e : "Unknown error";
      return {
        success: false,
        message: message,
      };
    }
  }
}

export const dataBaseService = new DataBaseService();
